import api from './api';

/**
 * 이벤트 관련 API 서비스
 */
const eventsService = {
  // 이벤트 목록 조회
  async getEvents(params = {}) {
    try {
      const response = await api.get('/events', { params });
      return response.data;
    } catch (error) {
      console.error('이벤트 목록 조회 실패:', error);
      throw error;
    }
  },

  // 이벤트 상세 조회
  async getEvent(id) {
    try {
      const response = await api.get(`/events/${id}`);
      return response.data;
    } catch (error) {
      console.error('이벤트 상세 조회 실패:', error);
      throw error;
    }
  },

  // 메인 고정 이벤트 조회
  // [2026-05-03] params 옵션 추가 — { limit }을 백엔드에 전달해 슬라이드 노출 한도 지정.
  //   미전달 시 백엔드 디폴트(30) 사용, 상한 100.
  async getPinnedEvents(params = {}) {
    try {
      const response = await api.get('/events/pinned/list', { params });
      return response.data;
    } catch (error) {
      console.error('메인 고정 이벤트 조회 실패:', error);
      throw error;
    }
  },

  // 진행중인 이벤트 조회
  async getActiveEvents() {
    try {
      const response = await api.get('/events/active');
      return response.data;
    } catch (error) {
      console.error('진행중 이벤트 조회 실패:', error);
      throw error;
    }
  },

  // 이벤트 조회수 증가
  async increaseViewCount(id) {
    try {
      const response = await api.post(`/events/${id}/view`);
      return response.data;
    } catch (error) {
      console.error('조회수 증가 실패:', error);
      throw error;
    }
  }
};

export default eventsService;